import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PageElement } from 'projects/service/src/app/shared/models/page.model';
import { ElementTypes } from '../../models/popup.model';

@Component({
    selector: 'app-popup-layout',
    templateUrl: './popup-layout.component.html',
    styleUrls: ['./popup-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupLayoutComponent implements OnInit {

    @Input() elements: PageElement[] = [];
    
    elementTypes = ElementTypes;

    constructor() { }

    ngOnInit(): void {
    }

}
